import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminShared.css";

import { API_BASE_URL } from "../config";

const UploadEvent = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fileRef = useRef(null);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/admin/eventposter`);
      setImages(res.data.reverse());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) return navigate("/admin");
    fetchImages();
  }, [navigate]);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected || !selected.type.startsWith("image/")) {
      alert("Please select a valid image file");
      return;
    }
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
    setPreview(URL.createObjectURL(selected));
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!title || !file) {
      alert("Please provide a title and select an image!");
      return;
    }
    const formData = new FormData();
    formData.append("name", title);
    formData.append("file", file);
    try {
      setLoading(true);
      await axios.post(`${API_BASE_URL}/admin/eventposter`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setTitle("");
      setFile(null);
      setPreview(null);
      alert("✅ Event asset synchronized.");
      fetchImages();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Purge event asset?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/admin/eventposter/${id}`);
      fetchImages();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading && images.length === 0) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Synchronizing Campaign Matrix...</p>
        </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Event Operations</h1>
        </div>
        <div className="module-badge" style={{ background: '#22c55e' }}>Campaigns</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#22c55e' }}></div>
            Status: Campaign Manager Ready
          </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
             <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '60px' }}>
                
                {/* Left Side: Upload Form */}
                <div style={{ paddingRight: '40px', borderRight: '1px solid #f1f5f9' }}>
                    <h2 style={{ marginBottom: '30px', fontWeight: 800 }}>Deploy New Campaign</h2>
                    <form className="admin-form-elite" style={{ padding: 0, border: 'none', boxShadow: 'none' }} onSubmit={handleUpload}>
                         <label>
                            Campaign Label
                            <input
                                type="text"
                                placeholder="e.g. Summer Workshop 2026"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </label>
                        <label>
                            Media Content
                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <button type="button" className="btn-update" style={{ display: 'block', width: 'fit-content' }} onClick={() => fileRef.current.click()}>
                                    📁 Select Media
                                </button>
                                {file && <span style={{ fontSize: '0.8rem', color: '#64748b' }}>{file.name}</span>}
                            </div>
                            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileChange} />
                        </label>

                        {preview && (
                            <div style={{ marginTop: '20px', borderRadius: '16px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                                <img src={preview} alt="Preview" style={{ width: '100%', height: 'auto', display: 'block' }} />
                            </div>
                        )}

                        <button className="btn-primary-elite" type="submit" disabled={loading} style={{ marginTop: '30px', width: '100%' }}>
                            {loading ? "Synchronizing Asset..." : "Push to Production"}
                        </button>
                    </form>
                </div>

                {/* Right Side: Gallery */}
                <div>
                    <h2 style={{ marginBottom: '30px', fontWeight: 800 }}>Live Campaigns</h2>
                    {images.length === 0 ? (
                        <p style={{ color: '#94a3b8', textAlign: 'center', padding: '50px' }}>No active campaigns detected.</p>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {images.map((img) => (
                                <div key={img._id} className="admin-data-item" style={{ padding: '15px' }}>
                                    <img
                                        src={`${API_BASE_URL}/admin/eventposter/${img._id}`}
                                        alt={img.name}
                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px' }}
                                    />
                                    <div style={{ flex: 1, paddingLeft: '20px' }}>
                                        <div style={{ fontWeight: 700, fontSize: '1rem' }}>{img.name}</div>
                                        <div style={{ color: '#64748b', fontSize: '0.8rem' }}>Asset Type: Image/Poster</div>
                                    </div>
                                    <button
                                        className="action-btn-elite btn-delete"
                                        onClick={() => handleDelete(img._id)}
                                    >
                                        🗑️ Purge
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

             </div>
        </div>
      </div>
    </div>
  );
};

export default UploadEvent;
